export default __webpack_public_path__ + "static/media/Cognisphere_Transparent.dab71225.png";